export {default} from './FeatureDetail'
